module.exports = __webpack_public_path__ + "img/image-2.3654aa23.png";